import { Controller } from "@hotwired/stimulus";

// Resolves one owner identity through an explicit lookup. Typing clears stale
// results; changing owner type re-runs the same no-match lookup so the revealed
// create form always matches the selected type.
export default class extends Controller {
  static targets = ["identity", "lookupForm", "ownerType", "lookupSubmit"];
  static classes = ["primary", "secondary"];

  // One filled action per view. The lookup button leads until a result
  // renders below it; from then on the result's own action is the primary one
  // and this drops back to the secondary treatment.
  resultRendered() {
    this.#setLookupPrimary(this.frame()?.innerHTML.trim() === "");
  }

  selectType(event) {
    if (!this.hasOwnerTypeTarget || !this.hasLookupFormTarget) return;

    this.ownerTypeTarget.value = event.params.type;
    this.lookupFormTarget.requestSubmit();
  }

  reset() {
    const frame = this.frame();
    if (!frame) return;

    frame.removeAttribute("src");
    frame.innerHTML = "";
    this.#setLookupPrimary(true);
  }

  clearIdentity() {
    if (!this.hasIdentityTarget) return;

    this.identityTarget.value = "";
    this.reset();
    this.identityTarget.focus();
  }

  frame() {
    return document.getElementById("owner_resolution");
  }

  #setLookupPrimary(primary) {
    if (!this.hasLookupSubmitTarget) return;

    const element = this.lookupSubmitTarget;
    const add = primary ? this.primaryClasses : this.secondaryClasses;
    const remove = primary ? this.secondaryClasses : this.primaryClasses;

    remove.forEach((token) => element.classList.remove(token));
    add.forEach((token) => element.classList.add(token));
  }
}
